import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import DropDownModal from '../drop-down-modal'
import BasicDateTimePicker from 'common/components/elements/inputs/date-picker'
import moment from 'moment'
import DateFormatter from 'common/utils/DateFormatter'
import CheckboxLabel from 'common/components/elements/inputs/checkbox-label'
import Switch from 'common/components/elements/inputs/switch';

const defaultDurations = [
   // { name: 'No limit', value: 0, isDefault: true },
   { name: '24 hours', value: 1, isDefault: true },
   { name: '2 days',  value: 2, isDefault: true },
   { name: '3 days',  value: 3, isDefault: true },
   { name: '7 days', value: 7, isDefault: true },
   { name: '30 days', value: 30, isDefault: true },
   { name: '60 days', value: 60, isDefault: true },
   { name: '90 days', value: 90, isDefault: true },
]

const bundleDurations = [
   {  name: '24 hours', value: 24, isDefault: true },
   {  name: '2 days', value: 48, isDefault: true },
   {  name: '3 days',  value: 72, isDefault: true },
   {  name: '5 days',  value: 120, isDefault: true },
   {  name: '7 days',  value: 168, isDefault: true },
   {  name: '14 days',  value: 336, isDefault: true },
   {  name: '30 days',  value: 720, isDefault: true },
   // {  name: 'Until I unpublish', value: 'infinite', isDefault: true },
]

const ContentDurationField = ({
   title,
   description,
   className,
   onChange,
   useDefaultStyles,
   duration,
   dropDownModalClasName,
   showPublicCountDown,
   isDurationEnabled,
   hideCountDownCheckbox,
   contentType,
   durationKeyName,
   durationListData,
   textClassName,
   screenWidth,
   children,
   datePickerCustomHandler,
   getCustomDurationDisplayNameByValue,
   customDatePickerMinDate,
   countDownCheckboxLabelComponent = null,
   durationDropdownScrollIntoViewOnOpenContent,
   disableSwitch = false,
   tooltipContent = '',
}) => {

   const [durations, setDuration] = useState(durationListData ? durationListData : (contentType === 'content_bundle_item' ? [...bundleDurations] : [...defaultDurations]))

   const getCustomDurationDisplayName = (duration) => {
      if(Boolean(getCustomDurationDisplayNameByValue)) {
         return getCustomDurationDisplayNameByValue(duration)
      }

      // Old logic ((
      return duration === 1 ? '24 hours' : `${ contentType !== 'content_bundle_item' ? duration : duration / 24 } ${ contentType !== 'content_bundle_item' ? 'days' : 'days' }`
   }

   useEffect(() => {
      if(!!duration && duration !== 0) {
         if(!['content_bundle_item'].includes(contentType)){
            let isExist = durations.find(({ value }) => value?.toString() === duration.toString())
            if(!isExist) {
               setDuration(prev => {
                  const customIndex = durations.findIndex(it => !it.isDefault);
                  let modifiedDurations = [...prev]

                  if(customIndex === -1) {
                     modifiedDurations = [
                        ...modifiedDurations,
                        {
                           name: getCustomDurationDisplayName(duration),
                           value: duration,
                        },
                     ]
                  } else {
                     modifiedDurations = modifiedDurations.map(it =>
                        it.value === durations[customIndex].value
                           ? { name: getCustomDurationDisplayName(duration), value: duration }
                           : it
                     );
                  }

                  return modifiedDurations.toSorted((a, b) => a.value - b.value)
               })
            }
         }
         // else {
         //    setDuration(duration)
         // }
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [duration])

   const getInitialValue = () => {

      switch (contentType) {
         case 'switch_membership':
            return {
               name: durations.find(it => it.value === duration)?.name || 'Custom',
               value: duration,
            }

         // Old logic ((
         default:
            return {
               name: !duration || duration === 0  ? durations[0].name :  duration === 1 ? '24 hours' : `${ contentType !== 'content_bundle_item' ? duration : duration !== 24 ? duration / 24 : duration } ${ contentType !== 'content_bundle_item' ? 'days' :  duration !== 24 ? 'days' : 'hours' }`,
               value: !duration ? durations[0].value : duration,
            }
      }
   }

   return (
      <div className={ cx({
         'flex flex-col gap-4 bg-panel w-full': true,
         [`rounded-lg border border-divider p-6`]: useDefaultStyles,
         [className]: !!className,
      }) }>
         <div className='flex flex-col gap-1'>
            <div className='flex justify-between items-center gap-3'>
               <p
                  className={ cx({
                     'panel-header text-major dark:text-major-dark intercom-duration': true,
                     [`${ textClassName }`]: textClassName,
                  }) }
               >
                  {title}
               </p>
               <Switch
                  onChange={ (name, value) => {
                     let data = {
                        duration_enabled: value,
                     }

                     if('poll' !== contentType && value) {
                        data = {
                           ...data,
                           [durationKeyName]: duration || (contentType === 'content_bundle_item' ? value ? 24 : 'infinite' : 1),
                        }
                     }

                     // if('poll' !== contentType) {
                     //    onChange(durationKeyName, contentType === 'content_bundle_item' ? value ? 24 : 'infinite' : 1)
                     // }

                     // onChange('duration_enabled', value)
                     onChange(data)
                  } }
                  checked={ isDurationEnabled }
                  className='duration_enabled'
                  dataTooltipContent={ tooltipContent }
                  disabled={ disableSwitch }
               />
            </div>
            <p className='panel-description text-secondary dark:text-secondary-dark '>{description}</p>
         </div>
         {
            isDurationEnabled &&
            <>
               <DropDownModal
                  data={ durations }
                  descriptionClassName='text-base text-major font-medium mb-2'
                  initialValue={ getInitialValue() }
                  uniqueId='duration-drop-down-modal'
                  activeValue={ duration || 0 }
                  onChange={ (data) => {
                     onChange({ [durationKeyName]: data.value })
                  } }
                  optionsListClassName={ `top-11 border-divider ${ dropDownModalClasName }` }
                  mainClassName='relative w-full'
                  maxHeight='240'
                  onInputClick={ () => {
                  } }
                  wrapperClassname=''
                  useModalForMobile
                  screenWidth={ screenWidth }
                  mobileSize={ 1024 }
                  targetClassToIgnoreOnClick='.MuiDialog-container'
                  scrollIntoViewOnOpenContent={ durationDropdownScrollIntoViewOnOpenContent }
               >
                  {
                     contentType !== 'content_bundle_item' &&
                     <BasicDateTimePicker
                        name='date'
                        type='date'
                        label='Custom'
                        labelClassName='font-medium text-sm !text-action cursor-pointer !m-0 px-3.5 py-2.5 hover:underline leading-tight w-fit'
                        value={ null }
                        minValue={ customDatePickerMinDate || moment().add(1, 'days').format('YYYY-MM-DD') }
                        onChangeDate={ (name, value) => {
                           if(datePickerCustomHandler) {
                              datePickerCustomHandler(value)
                              return;
                           }
                           const convertToUtc = value ? DateFormatter.convertToUtc(value) : null
                           if(!convertToUtc) return
                           const differenceInDays = moment(convertToUtc).diff(moment(), 'days') + 1
                           onChange({ [durationKeyName]: differenceInDays })
                        }  }
                        datePickerClassName={ `!hidden` }
                        onClickLabelOpenDatePicker
                     />
                  }
               </DropDownModal>
               {
                  !hideCountDownCheckbox &&
                  <CheckboxLabel
                     label='Show public countdown'
                     padding='0'
                     checked={ showPublicCountDown }
                     onChange={ () => {
                        onChange({ show_public_countdown: !showPublicCountDown })
                     } }
                  >
                     {countDownCheckboxLabelComponent}
                  </CheckboxLabel>
               }
               {children}
            </>
         }
      </div>
   )
}

ContentDurationField.propTypes = {
   title: PropTypes.string,
   description: PropTypes.string,
   className: PropTypes.string,
   dropDownModalClasName: PropTypes.string,
   onChange: PropTypes.func,
   useDefaultStyles: PropTypes.bool,
   duration: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
   ]),
   showPublicCountDown: PropTypes.bool,
   isDurationEnabled: PropTypes.bool,
   hideCountDownCheckbox: PropTypes.bool,
   contentType: PropTypes.string,
   durationKeyName: PropTypes.string,
   durationListData: PropTypes.array,
   textClassName: PropTypes.string,
   screenWidth: PropTypes.number,
   children: PropTypes.any,
   datePickerCustomHandler: PropTypes.func,
   getCustomDurationDisplayNameByValue: PropTypes.func,
   customDatePickerMinDate: PropTypes.any,
   countDownCheckboxLabelComponent: PropTypes.any,
   durationDropdownScrollIntoViewOnOpenContent: PropTypes.bool,
   disableSwitch: PropTypes.bool,
   tooltipContent: PropTypes.string,
}

ContentDurationField.defaultProps = {
   title: 'Duration',
   description: 'Set an amount of time after which you would like this to be unpublished',
   useDefaultStyles: true,
   dropDownModalClasName: '',
   showPublicCountDown: false,
   hideCountDownCheckbox: false,
   contentType: '',
   durationKeyName: 'unpublished_duration',
}

export default ContentDurationField
